import React from 'react';
import { AppLauncherEngine } from '../../components/workspace/AppLauncherEngine';
import { FinanceToolsRegistry } from './FinanceToolsRegistry';

export function MoneyDashboard() {
  return (
    <AppLauncherEngine 
      hubId="money" 
      hubName="Finance & Accounting" 
      tools={FinanceToolsRegistry} 
    />
  );
}
